import { render, staticRenderFns } from "./KanbanSettings.vue?vue&type=template&id=72799bdf&scoped=true"
import script from "./KanbanSettings.vue?vue&type=script&lang=js"
export * from "./KanbanSettings.vue?vue&type=script&lang=js"
import style0 from "./KanbanSettings.vue?vue&type=style&index=0&id=72799bdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72799bdf",
  null
  
)

export default component.exports